import * as api from '@/api';
import { storeOrganisation } from '@/utils/authentication.js';

export function toggleDim({ commit }, payload) {
    commit('setDim', payload);
}

export function toggleLock({ commit }, payload) {
    commit('setLock', payload);
}

export function setWindowHeight() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export async function loadOrganisation({ commit }, payload) {
    try {
        let organisationSlug = payload;
        const response = await api.organisation.get(organisationSlug);
        let linktrees = new Array();

        commit('setOrganisation', response.data.data);
        if (
            Object.prototype.hasOwnProperty.call(
                response.data.data,
                'link_trees',
            )
        )
            linktrees = response.data.data.link_trees.data;
        commit('setTrees', linktrees);

        storeOrganisation(response.data.data);
    } catch (error) {
        console.error(error);
    }
}

export async function loadTree({ commit }, payload) {
    commit('setActiveTree', false);
    commit('setManipulatedData', false);

    if (typeof payload.slug !== 'undefined') {
        try {
            const response = await api.linktree.get(payload.slug);
            commit('setActiveTree', response.data.data);
        } catch (error) {
            console.error(error);
        }
    }
}

export async function loadPublicTree({ commit }, payload) {
    commit('setActiveTree', false);
    commit('setManipulatedData', false);

    if (typeof payload.slug !== 'undefined') {
        try {
            const response = await api.linktree.publicTree(payload.slug);
            commit('setActiveTree', response.data.data);
        } catch (error) {
            console.error(error);
        }
    }
}

export function clearActiveTree({ commit }) {
    commit('setActiveTree', false);
}

export function clearManipulatedData({ commit }) {
    commit('setManipulatedData', false);
}

export function checkIfMobileNav({ commit, state }) {
    const windowWidth = window.innerWidth;
    commit('setMobileNav', windowWidth < state.breakpoints.tabletLandscape);
}
